import moment from 'moment';
import styles from '../../assets/styles/Vendor/Vendor.module.scss';
import { MimaText, Modal } from '../../components';
import React from 'react';

const ViewVendor = ({
	closeModal,
	showVendorViewMenu,
	vendor,
	vendorViewMenu,
	goToEditVendor,
	goBack,
}) => {
	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			<MimaText variant="subtitle" color="var(--color-primary)" align="center">
				{vendor.name}
			</MimaText>
			<div className={styles.view_content}>
				<MimaText labelTitle="Phone Number" mb={2}>
					{vendor.mobile}
				</MimaText>
				<MimaText labelTitle="Alternate Phone Number" mb={2}>
					{vendor.secondaryMobile}
				</MimaText>
				<MimaText labelTitle="Email Address" mb={2}>
					{vendor.email}
				</MimaText>
				<MimaText labelTitle="Services" mb={2}>
					{vendor.services}
				</MimaText>
				<MimaText labelTitle="Street" mb={2}>
					{vendor.street}
				</MimaText>
				<MimaText labelTitle="State" mb={2}>
					{vendor.state}
				</MimaText>
				<MimaText labelTitle="Country" mb={2}>
					{vendor.country}
				</MimaText>
				<MimaText labelTitle="Instagram Handle" mb={2}>
					{vendor.instagramHandle}
				</MimaText>
				<MimaText labelTitle="Relationship Start Date" mb={2}>
					{vendor.relationshipStartDate ? moment(vendor.relationshipStartDate).format('DD MMMM YYYY') : ''}
				</MimaText>
				<MimaText labelTitle="Contact Person Name" mb={2}>
					{vendor.contactPersonName}
				</MimaText>
				<MimaText labelTitle="Contact Person Email" mb={2}>
					{vendor.contactPersonEmail}
				</MimaText>
				<MimaText labelTitle="Contact Person Phone" mb={2}>
					{vendor.contactPersonPhone}
				</MimaText>
			</div>
		</Modal>
	);
};

export default ViewVendor;
